import { Button } from "PFComponents/button";
import { Card } from "PFComponents/card";
import { InputFieldSet } from "PFComponents/text/input_field_set";
import { Typography } from "PFComponents/typography";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Template } from "../types";
import { inputsData } from "./consts";
import css from "./styles.module.scss";
import { FormValues } from "./types";

interface Props {
  data: Template;
  onCancel: () => void;
  onSubmit: (values: FormValues) => void;
}

const EditInterestQuestionsPage = ({ data, onCancel, onSubmit }: Props): JSX.Element => {
  const { t } = useTranslation(["interestQuestions", "translation"]);

  const {
    control,
    handleSubmit,
    watch,
    formState: { errors, isDirty }
  } = useForm<FormValues>({
    defaultValues: {
      question1: data.question1 || "",
      question2: data.question2 || "",
      question3: data.question3 || ""
    }
  });

  const values = watch();

  const onValidSubmit = (form: FormValues) => {
    const formTrimmedQuestions: FormValues = {
      ...form,
      question1: form.question1!.trim(),
      question2: form.question2!.trim(),
      question3: form.question3!.trim()
    };

    onSubmit(formTrimmedQuestions);
  };

  return (
    <Card className={css.cardRoot} paddingVariant="xl">
      <Typography variant="h2">{t("interestQuestions:edit.title")}</Typography>
      <Typography variant="h5">
        {t("interestQuestions:edit.subtitle", {
          // @ts-ignore
          activity: t(`interestQuestions:templates.${data.templateKey}`)
        })}
      </Typography>

      <form onSubmit={handleSubmit(onValidSubmit)}>
        <div className={css.formWrapper}>
          {inputsData.map(({ id, name }) => {
            const isNextFieldFilled = inputsData
              .filter((input) => input.id > id)
              .some((input) => (values[input.name] as string).trim());

            return (
              <Controller
                key={id}
                name={name}
                control={control}
                rules={{
                  validate: (value: string) =>
                    isNextFieldFilled && !value.trim()
                      ? t("interestQuestions:edit.fillQuestionsInProperOrder")
                      : true
                }}
                render={({ field }) => (
                  <InputFieldSet
                    kind="bordered"
                    maxLength={120}
                    label={t("interestQuestions:edit.questionLabel", { id })}
                    name={field.name}
                    value={field.value || ""}
                    error={errors[field.name]?.message}
                    onChange={field.onChange}
                    onBlur={field.onBlur}
                    className={css.input}
                  />
                )}
              />
            );
          })}
        </div>

        <div className={css.buttons}>
          <Button type="button" kind="secondary" onClick={onCancel}>
            {t("translation:cancel")}
          </Button>
          <Button type="submit" disabled={!isDirty}>
            {t("translation:save")}
          </Button>
        </div>
      </form>
    </Card>
  );
};

export default EditInterestQuestionsPage;
